<div class="row">
  <div class="col">
	  <label class="label" [innerHtml]="getLabel() | safeHtml"></label>
	  <app-audioplayer *ngIf="formItem?.item?.allowAudio && formItem?.item?.audioFileName != '' && formItem.item?.audioFileName != null" [formItem]="formItem" [formId]="formId"></app-audioplayer>
  </div>
</div>
